







import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { StringFilterParameter } from "../../system/filters";
import StringFilter from "../../system/filters/StringFilter.vue";
import { FormatReferenceDirectoryFilterParameter } from ".";

@Component({
  components: {
    StringFilter,
  },
})
export default class FormatReferenceDirectoryFilter extends Mixins(ModelEditableMixin) {
  editingSource: FormatReferenceDirectoryFilterParameter;

  get name(): StringFilterParameter {
    return this.editingSource.name;
  }

  set name(source: StringFilterParameter) {
    this.writeProperty(s => s.name = source);
  }
}
